import { useCallback, useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { env } from 'utils'
import { type Address, createPublicClient, http } from 'viem'
import { base } from 'viem/chains'

export const useBalanceOnChain = (address: Address | undefined, chainId: number) => {
    const rpcUrl = useMemo(() => {
        switch (chainId) {
            case 8453:
                return env.VITE_BASE_CHAIN_RPC_URL
            default:
                return undefined
        }
    }, [chainId])

    const publicClient = useMemo(() => {
        return createPublicClient({
            chain: base,
            transport: http(rpcUrl),
        })
    }, [rpcUrl])

    const fetchETHBalance = useCallback(
        async (blockNumber?: number): Promise<bigint> => {
            if (!address || !publicClient) {
                return 0n
            }

            return publicClient.getBalance({
                address,
                ...(blockNumber ? { blockNumber: BigInt(blockNumber) } : {}),
            })
        },
        [publicClient, address],
    )

    const { data, isLoading } = useQuery({
        queryKey: ['trading-use-balance', chainId],
        queryFn: () => fetchETHBalance(),
        enabled: !!rpcUrl && !!publicClient && !!address,
    })

    return {
        data: data ?? 0n,
        isLoading,
        fetchETHBalance,
    }
}
